
import { Component, Prop, Vue } from 'vue-property-decorator'
import ColorContentUnitBox from '@/components/molecules/ColorContentUnitBox.vue'
import { NoticeMessageData } from '@/models/NoticeMessage'

/**
 * トップページお知らせパネルのコンテンツボックス
 */
@Component({
  components: {
    ColorContentUnitBox,
  },
})
export default class TopPageNoticeContentBox extends Vue {
  /** お知らせ情報 */
  @Prop()
  private notice!: NoticeMessageData

  /** コンテンツボックスクリック時のイベント */
  @Prop()
  private eventClickBox!: (id: number) => void

  /**
   * 色指定
   *
   * TODO お知らせ種別による色指定を検討
   */
  private colorCode = '--color-top__message-main'
}
